<div fxLayout="row" fxLayoutAlign="space-around start" class="device-details-div">
    <div fxFlex="5"></div>
    <div fxFlex="50">
      <mat-card style="font-family: 'Roboto', sans-serif;">
        <mat-card-header>
          <mat-card-title style="font-size: x-large;">Device Details</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div>
            <h1></h1>
  
            <table class="table" id="device-details-table">
              <tbody>
                <tr *ngFor="let key of device | keys">
                  <th>{{ key }}</th>
                  <td>{{device[key]?.toString() }}</td>
                </tr>
              </tbody>
            </table>
  
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  